// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__1jij6","container":"styles_container__3o_zC","title":"styles_title__2ydfP","wrapper":"styles_wrapper__txn9x","answer":"styles_answer__1gKJ5"};